import { handleActions } from 'redux-actions';
import omit from 'lodash/omit';
import getAgent from '@egjs/agent';
import { initSecurityPage } from '../../actions';
import { NetworkRequestState } from '../baseTypes';
import { SessionsWidgetData, UserAgentDeviceType } from './types';
import {
  logoutSession,
  logoutSessionFailure,
  logoutSessionSuccess,
} from './actions';
import { defaultSessionsWidgetState } from './defaults';

export default handleActions<SessionsWidgetData, any>(
  {
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => {
      return {
        sessions: action.payload.data.sessions.reduce(
          (acc, session): SessionsWidgetData['sessions'] => {
            const parsedAgent = getAgent(session.userAgent);
            acc[session.sessionId] = {
              ...session,
              userAgent: session.userAgent
                ? {
                    deviceType: parsedAgent.isMobile
                      ? UserAgentDeviceType.Mobile
                      : UserAgentDeviceType.Desktop,
                    parsedAgent,
                  }
                : undefined,
              logoutRequest: {
                status: NetworkRequestState.IDLE,
              },
            };
            return acc;
          },
          {}
        ),
      };
    },
    [logoutSession.toString()]: (
      state,
      action: ReturnType<typeof logoutSession>
    ) => ({
      ...state,
      sessions: {
        ...state.sessions,
        [action.payload.sessionId]: {
          ...state.sessions[action.payload.sessionId],
          logoutRequest: {
            status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
          },
        },
      },
    }),
    [logoutSessionSuccess.toString()]: (
      state,
      action: ReturnType<typeof logoutSessionSuccess>
    ) => ({
      ...state,
      sessions: omit(state.sessions, action.payload.sessionId),
    }),
    [logoutSessionFailure.toString()]: (
      state,
      action: ReturnType<typeof logoutSessionFailure>
    ) => ({
      ...state,
      sessions: {
        ...state.sessions,
        [action.payload.sessionId]: {
          ...state.sessions[action.payload.sessionId],
          logoutRequest: {
            status: NetworkRequestState.FAILURE,
            errorMessage: action.payload.errorMessage,
          },
        },
      },
    }),
  },
  defaultSessionsWidgetState
);
